import React from 'react';
import { Button } from './ui/button';
import { Bell } from 'lucide-react';

/**
 * "Precision Alerts" section: intro copy on the left, mock alert cards on the right.
 */
const FeaturePrecisionAlerts = ({ t, pick }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <div className="grid md:grid-cols-2 gap-12 items-center">
      <div>
        <div className="inline-block px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full mb-6">
          <span className="text-purple-400 text-sm font-semibold">{pick('alerts_badge')}</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {pick('alerts_title1')}
          <br />
          <span className="bg-gradient-to-r from-purple-400 to-pink-400 text-transparent bg-clip-text">
            {pick('alerts_title2')}
          </span>
        </h2>
        <p className="text-lg text-white/70 mb-8">{pick('alerts_description')}</p>
        <Button size="lg" className="bg-white text-black hover:bg-white/90">
          {pick('alerts_cta')}
        </Button>
      </div>

      <div className="relative">
        <div className="bg-gradient-to-br from-purple-500/10 to-pink-500/10 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="space-y-4">
            <AlertCard
              borderColor="border-green-500/30"
              iconColor="text-green-400"
              title={t.features.precisionAlerts.btcAlert}
              desc={t.features.precisionAlerts.btcAlertDesc}
              age="2 min ago"
            />
            <AlertCard
              borderColor="border-cyan-500/30"
              iconColor="text-cyan-400"
              title={t.features.precisionAlerts.nasdaqAlert}
              desc={t.features.precisionAlerts.nasdaqAlertDesc}
              age="15 min ago"
            />
            <AlertCard
              borderColor="border-orange-500/30"
              iconColor="text-orange-400"
              title={t.features.precisionAlerts.ethAlert}
              desc={t.features.precisionAlerts.ethAlertDesc}
              age="1 hour ago"
            />
          </div>
        </div>
        <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 blur-3xl -z-10"></div>
      </div>
    </div>
  </section>
);

const AlertCard = ({ borderColor, iconColor, title, desc, age }) => (
  <div className={`flex items-start space-x-4 bg-white/5 border ${borderColor} rounded-lg p-4`}>
    <Bell className={`${iconColor} mt-1`} size={20} />
    <div className="flex-1">
      <div className="flex justify-between items-center mb-1">
        <span className="text-white font-semibold text-sm">{title}</span>
        <span className="text-white/60 text-xs">{age}</span>
      </div>
      <p className="text-white/80 text-sm">{desc}</p>
    </div>
  </div>
);

export default FeaturePrecisionAlerts;
